import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'helpers/verify';
import { CmsModules, CmsModuleShape } from 'containers/CmsPage/CmsModules';
import { HeadingTag } from 'components/CmsPage/modules/CmsHeading/CmsHeading';
import { CmsText } from 'components/CmsPage/modules/CmsText/CmsText';
import { Section } from 'components/Section/Section';
export var ProductCard = function ProductCard(_ref) {
  var callout = _ref.callout,
      calloutNote = _ref.calloutNote,
      cmsModuleId = _ref.cmsModuleId,
      cta = _ref.cta,
      details = _ref.details,
      modules = _ref.modules,
      tag = _ref.tag;
  return React.createElement("div", {
    className: "card"
  }, React.createElement(Section, {
    className: "ProductCard"
  }, tag && React.createElement("div", {
    className: "ProductCard__tag"
  }, React.createElement("span", null, tag)), React.createElement("header", {
    className: "ProductCard__callout"
  }, React.createElement(HeadingTag, {
    className: "ProductCard__callout-value",
    title: callout
  }), React.createElement(CmsText, {
    className: "ProductCard__callout-unit",
    cmsModuleId: "ProductCard:Note:".concat(cmsModuleId),
    content: calloutNote
  })), isEmpty(modules) && details && React.createElement("div", {
    className: "ProductCard__content"
  }, React.createElement(CmsText, {
    cmsModuleId: "ProductCard:Details:".concat(cmsModuleId),
    content: details,
    size: "medium"
  })), !isEmpty(modules) && React.createElement("div", {
    className: "ProductCard__content"
  }, React.createElement(CmsModules, {
    modules: modules
  })), cta && React.createElement("div", {
    className: "ProductCard__cta"
  }, cta)));
};
ProductCard.propTypes = {
  callout: PropTypes.string,
  calloutNote: PropTypes.node,
  cmsModuleId: PropTypes.string.isRequired,
  cta: PropTypes.node,
  details: PropTypes.node,
  modules: PropTypes.arrayOf(CmsModuleShape),
  tag: PropTypes.node
};